import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Typography,
    Paper,
    Chip,
    Button,
    CircularProgress
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }
});

const StandardPresetForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, productTypes, loading } = props;

    return (
        <Paper className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isSubmitting, isValid, dirty, handleChange, setFieldValue, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{translations['storage_area'] || 'Storage Area'}</Typography>
                            <TextField
                                name="StorageAreaName"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["storage_area_name"] || "Storage Area Name"}
                                label={translations["storage_area_name"] || "Storage Area Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="StorageAreaHeight"
                                value={values.Height}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Height && touched.Height)}
                                placeholder={translations["storage_area_height"] || "Storage Area Height"}
                                label={translations["storage_area_height"] || "Storage Area Height"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="StorageAreaWidth"
                                value={values.Width}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Width && touched.Width)}
                                placeholder={translations["storage_area_width"] || "Storage Area Width"}
                                label={translations["storage_area_width"] || "Storage Area Width"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="StorageAreaLength"
                                value={values.Length}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Length && touched.Length)}
                                placeholder={translations["storage_area_length"] || "Storage Area Length"}
                                label={translations["storage_area_length"] || "Storage Area Length"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="StorageAreaMaxWeight"
                                value={values.MaxWeight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MaxWeight && touched.MaxWeight)}
                                placeholder={translations["storage_area_max_weight"] || "Storage Area Max weight"}
                                label={translations["storage_area_max_weight"] || "Storage Area Max weight"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <br />
                            <br />
                            <Typography variant={"h6"}>{translations['palette'] || 'Palette'}</Typography>
                            <TextField
                                name="PaletteName"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["palette_name"] || "Palette Name"}
                                label={translations["palette_name"] || "Palette Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="PaletteHeight"
                                value={values.Height}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Height && touched.Height)}
                                placeholder={translations["palette_height"] || "Palette Height"}
                                label={translations["palette_height"] || "Palette Height"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="PaletteWidth"
                                value={values.Width}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Width && touched.Width)}
                                placeholder={translations["palette_width"] || "Palette Width"}
                                label={translations["palette_width"] || "Palette Width"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="PaletteLength"
                                value={values.Length}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Length && touched.Length)}
                                placeholder={translations["palette_length"] || "Palette Length"}
                                label={translations["palette_length"] || "Palette Length"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <TextField
                                name="PaletteMaxWeight"
                                value={values.MaxWeight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MaxWeight && touched.MaxWeight)}
                                placeholder={translations["palette_max_weight"] || "Palette Max weight"}
                                label={translations["palette_max_weight"] || "Palette Max weight"}
                                margin={"dense"}
                                fullWidth={true}
                                type={"number"}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString()
                                }}
                            />
                            <Autocomplete
                                name={'PaletteProductTypeIDs'}
                                multiple
                                id="ProducTypeMultiSelect"
                                options={productTypes || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.PaletteProductTypeIDs}
                                onChange={(_, value) => { setFieldValue('PaletteProductTypeIDs', value) }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["choose_product_type"] || "Choose product type"}...`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(StandardPresetForm);


/**
 * Translations:
 *  name
 *  width
 *  height
 *  max_weight
 */